import React from 'react';
import CTAButton from '../../components/CTAButton';
import './Home.css';

const Home = () => {
  return (
    <main>
      {/* Hero Section */}
      <section id="home" className="hero-section">
        <div className="hero-background">
          <div className="neural-network-bg"></div>
        </div>
        <div className="hero-content">
          <h1 className="hero-headline">Intelligent Automation, Delivered.</h1>
          <p className="hero-subheadline">
            We build AI and Cloud solutions that create real business impact - Fast, Scalable, and Secure.
          </p>
          <CTAButton variant="primary" size="large" href="/contact">Build Your AI Solution</CTAButton>
        </div>
      </section>

      {/* Core Services Overview Section */}
      <section id="services" className="services-section">
        <div className="container">
          <h2 className="section-title">Our Core Solutions</h2>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/>
                </svg>
              </div>
              <h3>AI & Machine Learning</h3>
              <p>We design and deploy custom AI/ML-powered assistants, predictors, and analytics systems to solve your most complex business problems.</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"/>
                  <path d="M12 12v.01"/>
                </svg>
              </div>
              <h3>Cloud & AI Automation</h3>
              <p>Our expertise in AWS, Docker, and CI/CD ensures your AI solutions are built on a secure, scalable, and automated cloud-native architecture.</p>
            </div>
            
            <div className="service-card">
              <div className="service-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"/>
                </svg>
              </div>
              <h3>Intelligent Applications</h3>
              <p>We create user-friendly full-stack and mobile applications (React, React Native, Node.js) that serve as the powerful interface for your AI systems.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section id="about" className="why-choose-section">
        <div className="container">
          <h2 className="section-title">Your Partner in Digital Transformation</h2>
          <div className="why-choose-content">
            <div className="why-choose-image">
              <div className="image-placeholder">
                <svg viewBox="0 0 120 120" fill="none" stroke="currentColor" strokeWidth="2">
                  {/* Central AI Brain/Network */}
                  <circle cx="60" cy="60" r="25" fill="none" stroke="currentColor" strokeWidth="3"/>
                  <path d="M60 35 L60 45 M60 75 L60 85 M35 60 L45 60 M75 60 L85 60" stroke="currentColor" strokeWidth="2"/>
                  <path d="M50 50 L70 70 M70 50 L50 70" stroke="currentColor" strokeWidth="2"/>
                  
                  {/* Connected Nodes */}
                  <circle cx="30" cy="30" r="8" fill="none" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="90" cy="30" r="8" fill="none" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="30" cy="90" r="8" fill="none" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="90" cy="90" r="8" fill="none" stroke="currentColor" strokeWidth="2"/>
                  
                  {/* Connection Lines */}
                  <path d="M38 38 L50 50" stroke="currentColor" strokeWidth="1.5"/>
                  <path d="M82 38 L70 50" stroke="currentColor" strokeWidth="1.5"/>
                  <path d="M38 82 L50 70" stroke="currentColor" strokeWidth="1.5"/>
                  <path d="M82 82 L70 70" stroke="currentColor" strokeWidth="1.5"/>
                  
                  {/* Data Flow Arrows */}
                  <path d="M25 60 L15 60 M105 60 L115 60" stroke="currentColor" strokeWidth="1.5" markerEnd="url(#arrowhead)"/>
                  <path d="M60 25 L60 15 M60 105 L60 115" stroke="currentColor" strokeWidth="1.5" markerEnd="url(#arrowhead)"/>
                  
                  {/* Arrow Markers */}
                  <defs>
                    <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="9" refY="3.5" orient="auto">
                      <polygon points="0 0, 10 3.5, 0 7" fill="currentColor"/>
                    </marker>
                  </defs>
                  
                  {/* Floating Tech Elements */}
                  <circle cx="20" cy="20" r="3" fill="currentColor" opacity="0.6"/>
                  <circle cx="100" cy="20" r="3" fill="currentColor" opacity="0.6"/>
                  <circle cx="20" cy="100" r="3" fill="currentColor" opacity="0.6"/>
                  <circle cx="100" cy="100" r="3" fill="currentColor" opacity="0.6"/>
                </svg>
              </div>
            </div>
            <div className="why-choose-benefits">
              <div className="benefit-item">
                <div className="benefit-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/>
                  </svg>
                </div>
                <div className="benefit-content">
                  <h3>Problem Solvers, Not Just Coders</h3>
                  <p>Having grown through real-world engineering, we deeply understand business pain points and deliver solutions that are fast, reliable, and impactful.</p>
                </div>
              </div>
              
              <div className="benefit-item">
                <div className="benefit-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </div>
                <div className="benefit-content">
                  <h3>Guaranteed Delivery & Support</h3>
                  <p>Our clients benefit from a 100% delivery track record, complete IP ownership, and dedicated 24/7 support.</p>
                </div>
              </div>
              
              <div className="benefit-item">
                <div className="benefit-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </div>
                <div className="benefit-content">
                  <h3>Global Experience</h3>
                  <p>With successful projects delivered across the USA, India, and beyond, we are a trusted technology partner for startups and enterprises alike.</p>
                </div>
              </div>
              
              <CTAButton variant="secondary" href="/about">Learn Our Story</CTAButton>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact-section">
        <div className="container">
          <h2 className="section-title">Ready to Transform Your Business?</h2>
          <p className="contact-subtitle">Let's discuss how AI and Cloud solutions can drive your business forward.</p>
          <CTAButton variant="primary" size="large" href="/contact">Schedule Consultation</CTAButton>
        </div>
      </section>
    </main>
  );
};

export default Home;
